import { Capacitor } from "@capacitor/core"

const isNative = Capacitor.isNativePlatform()
const BASE = isNative ? import.meta.env.VITE_API_URL : ''

export const URL = BASE + '/api'
export const TKN = '@5-techs/token'
export const USR = '@5-techs/user'
export const TOLERANCIA_EXPIRACAO_TOKEN_MS = 30 * 60 * 1000
